import { CalendarDays } from "lucide-react";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { EntryValueChip } from "./EntryValueChip";
import { formatEntryDate } from "./formatEntryDate";

export interface MonthYearEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function MonthYearEntryValue({ value, inputLabel, size, className, ...props }: MonthYearEntryValueProps) {
    const formatted = formatEntryDate(value, "MMMM YYYY");
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <EntryValueChip icon={formatted ? CalendarDays : undefined} size={size}>
                {formatted ?? "None"}
            </EntryValueChip>
        </BaseEntryValue>
    );
}
